import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/e3dc_more.svg"

const e3dcmore: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 74 74'} component={Icon} {...props} fill="currentColor" />
export default e3dcmore
